class HtmlHelper
{
    public static icon(type : string, tooltip? : string) :string
    {
        return "<i class='fa fa-" + type + "' " + (tooltip  ? " data-toggle='tooltip' title='" + tooltip + "'" : '')  + "></i>";
    }

    public static link(content : string, caller : string, options : {[key:string]:string}) : string
    {
        var html : string = "<a href='" + caller + "'";

        for(var key in options)
        {
            html += " " + key + "='" + options[key] + "'";
        }

        html += '>' + content + "</a>";
        return html;
    }
}